var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaysFinanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB0473BA-4181-4073-8585-DF6D09D2D0D6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.000000, -233.000000)",
    stroke: "#95A6B0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 234.253906)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9.04347826 3.4986 9.04347826 7.3486 12.5217391 7.3486"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0.347826087 4.8944 2.43478261 8.0444 4.86956522 5.2444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04347826,13.65 C12.6933601,13.65 15.6521739,10.6726936 15.6521739,7 C15.6521739,3.32730641 12.6933601,0.35 9.04347826,0.35 C5.39359644,0.35 2.43478261,3.32730641 2.43478261,7 L2.43478261,8.0458"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysFinanced);
export default __webpack_public_path__ + "static/media/daysFinanced.cbcdeb98554472a82fbf279d19b915c4.svg";
export { ForwardRef as ReactComponent };